import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c80a7c24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tech-flex" }
const _hoisted_2 = { class: "notifications" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "static" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "icons" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-gear clickable" }, null, -1))

import UserEdeavoursControl from '@/components/Workspaces/users/_spec/UserEdeavoursControl.vue'
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { useAppContext } from '@/app/_tech';
import { reactive, watch } from 'vue';
import { useRouter } from 'vue-router'
import { TicketAccessLevel } from '@/controllers/workspaces/user.controller.workspace';
import * as personProcessor from '@/ops/workspaces/person.processor'
import {endeavours as endeavours_get} from '@/controllers/workspaces/user.controller.workspace'
//src\controllers\workspaces\user.controller.workspace.ts



export default /*#__PURE__*/_defineComponent({
  __name: 'TopbarControl.Person',
  props: {
    person: {},
    notifications: {},
    level: {}
  },
  setup(__props: any) {

const context = useAppContext()

const router = useRouter()

const props = __props

const model: { strict: boolean } = reactive({ strict: props.person.strict })

const endeavours = endeavours_get(context)

function navigatePersonTimeline(person: PersonRmodel) {
    router.push({ name: 'person-timeline', params: { person: person.name, workspace: person.workspace.name } })
}

function onStrictChanged() {



    context.storages.workspace!.personStrictnessUpdate(props.person.workspace.wid, props.person.nid, model.strict)

}




watch(() => props.person.strict, () => {



    model.strict = props.person.strict


})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UserEdeavoursControl, {
      class: "endeavours",
      items: _unref(endeavours)
    }, null, 8, ["items"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (n, i) => {
        return (_openBlock(), _createElementBlock("span", { key: i }, [
          (i != 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" •")
              ], 64))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(n), 1)
        ]))
      }), 128))
    ]),
    (_ctx.person.subordinate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.strict) = $event)),
            onChange: onStrictChanged,
            disabled: props.level < _unref(TicketAccessLevel).Full
          }, null, 40, _hoisted_4), [
            [_vModelCheckbox, model.strict]
          ]),
          _createTextVNode(" Strict mode ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (!_ctx.person.user)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "[N/U]"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("i", {
        class: "bi-card-checklist clickable",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (navigatePersonTimeline(_ctx.person)))
      }),
      _hoisted_8,
      (_ctx.person.subordinate && !_ctx.person.stopped && _ctx.level >= _unref(TicketAccessLevel).Normal)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (personProcessor.stop(_unref(context), _ctx.person, true))),
            class: "bi bi-exclamation-square clickable"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})